<div class="container">
  <div class="row">
    <div class="col">
      <div class="forgot-password-container">
        <div class="login-page-logo">
          <img
            src="assets/images/logo-tr@3x.png"
            srcset="assets/images/logo-tr@3x.png 2x, assets/images/logo-tr@3x.png 3x"
            class="logo"
            width="70%"
          />
        </div>
        <div class="page-title">Forgot your password</div>
        <div class="page-subtitle">
          Please enter your username. If that exists We'll send you a link to set
          a new password.

          <div
            class="invalid-input"
            role="alert"
            *ngIf="responseError && responseError?.error"
          >
            {{ responseError?.error?.message }}
          </div>
          <form
            name="fogotPasswordForm"
            [formGroup]="fogotPasswordForm"
            novalidate
          >
            <div class="form-group">
              <div class="username">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Username"
                  formControlName="username"
                />
              </div>
            </div>

            <button
              class="btn btn-primary w-100"
              (click)="submitForm(fogotPasswordForm.value)"
              [disabled]="fogotPasswordForm.invalid || isLoader"
            >
              <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader"></i>-->
              Send
            </button>
          </form>

          <div class="text-center mt-4">
            <a
              role="button"
              class="link"
              routerLink="/login"
              class="font-weight-500 text-primary"
              >Back to Login</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
